import { useEffect } from 'react';
import { useUi } from '@/app/store';

export function Toast() {
  const toast = useUi((s) => s.toast);
  const hide = useUi((s) => s.hideToast);
  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(hide, 2600);
    return () => clearTimeout(t);
  }, [toast, hide]);
  if (!toast) return null;
  return <div className={`toast${toast.error ? ' err' : ''}`} role="status">{toast.text}</div>;
}
